let projectServiceBaseURL;
//uncomment 4 lines after props.LoginFunction and   props.verifyOtp( in LoginComponent.js once you provide correct to for login
//remove 13 lines from //--start-- in logincomponent.js

// if (process.env.REACT_APP_ENV === "production") {
//   projectServiceBaseURL = "https://ssipl.herokuapp.com/api/";
// } else {
//   projectServiceBaseURL = "https://ssipl.herokuapp.com/api/";
// }


//  Development
// if (process.env.REACT_APP_ENV === "production") {
//   projectServiceBaseURL = "https://ssipldev.grainbyte.app/bri/api/";
// } else {
//   projectServiceBaseURL = "https://ssipldev.grainbyte.app/bri/api/";
// }
if (process.env.REACT_APP_API_BASE_URL) {
  projectServiceBaseURL = process.env.REACT_APP_API_BASE_URL;
} else if (process.env.REACT_APP_ENV === "production") {
  // projectServiceBaseURL = "https://bridev.smilebots.com/api/";
  projectServiceBaseURL = "https://bri.smilebots.com/api/";
} else {
  // projectServiceBaseURL = "https://bridev.smilebots.com/api/";
  projectServiceBaseURL = "https://bri.smilebots.com/api/";
}
// test sserver
// if (process.env.REACT_APP_ENV === "production") {
//   projectServiceBaseURL = "https://dev.grainbyte.app/bri/api/";
// } else {
//   projectServiceBaseURL = "https://dev.grainbyte.app/bri/api/";
// }

 
// if (process.env.REACT_APP_ENV === "production") {
//   projectServiceBaseURL = "http://103.71.21.114:5000/api/";
// } else {
//   projectServiceBaseURL = "http://103.71.21.114:5000/api/";
// }
export const HOST  = 'https://bridev.smilebots.com/';
export const loginURL = projectServiceBaseURL + "auth/";

export const verifyOtpURL = projectServiceBaseURL + "auth/user-auth/verify-otp/";
export const baseURL = () => {
  return projectServiceBaseURL;
};
export const mergeProjectUrl = (api) => {
  return projectServiceBaseURL + api
};
export const moduleURL = (module,noSlash) => {
  return projectServiceBaseURL + module +(noSlash?"": "/");
};
export const moduleIdURL = (module, id,noSlash) => {
  return projectServiceBaseURL + module + "/" + id + (noSlash?"":"/");
};
export const noFmoduleIdURL = (module) => {
  return projectServiceBaseURL + module;
};
